// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"modal_imgContainer__6yJ2o","item":"modal_item__1iMHz","textContainer":"modal_textContainer__3Hmiv"};